import React from "react";
import DocumentUploadField from "../elements/document-upload-field";

export default function NationalId(props: any) {
  return (
    <DocumentUploadField
      title="Valid National ID"
      onUploaded={props.setNationalId}
    />
  );
}
